import { ApiConnector } from 'Connectors/ApiConnector';
import ConfigProxy      from 'tools/ConfigProxy';
import AbstractApiModel from './AbstractApiModel';

export const salesConnector = new ApiConnector({
	baseURL: ConfigProxy.getServiceConfig('sales', 'api_endpoint'),
});

export default class SalesApiModel extends AbstractApiModel {
	public static get connector() {
		return salesConnector;
	}

	public static serviceName: ServiceName = 'sales';
}
